import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";

const DelayWords = () => {
  const texts = useMemo(
    () => [
      { content: "land", className: "text-main" },
      { content: "+", className: "text-main-light" },
      { content: "cookie", className: "text-main" },
      { content: "=", className: "text-main-light" },
      { content: "lookie", isImage: true, imageSrc: "./lookie_logo_text.png" },
    ],
    []
  );

  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const [isMoved, setIsMoved] = useState(false); // 控制左側移動狀態
  const [showRightText, setShowRightText] = useState(false); // 控制右側文字顯示
  const [hasPlayed, setHasPlayed] = useState(false); // 控制動畫只播放一次
  const containerRef = useRef(null);

  useEffect(() => {
    const currentContainer = containerRef.current; // 儲存 containerRef.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasPlayed) {
          setHasPlayed(true); // 標記動畫已播放

          // 開始播放左側動畫
          texts.forEach((_, index) => {
            setTimeout(() => {
              setVisibleIndexes((prev) => [...prev, index]);
            }, index * 700);
          });

          // 啟動左側移動動畫和右側文字顯示
          setTimeout(() => {
            setIsMoved(true);
            setTimeout(() => setShowRightText(true), 1000); // 左移完成後顯示右側文字
          }, texts.length * 700 + 500);
        }
      },
      { threshold: 0.5 } // 當 50% 的區塊進入螢幕時觸發
    );

    if (currentContainer) {
      observer.observe(currentContainer);
    }

    return () => {
      if (currentContainer) {
        observer.unobserve(currentContainer);
      }
    };
  }, [hasPlayed, texts]);

  return (
    <div ref={containerRef} className="h-64 md:h-48 w-full relative">
      <div className={clsx(["w-full relative md:h-48 h-64"])}>
        {/* 左側動畫字 md以上 */}
        <div
          className={`absolute hidden left-1/2 transform -translate-x-1/2  md:flex flex-row items-baseline  text-4xl font-bold text-center space-x-4 transition-transform duration-[1500ms] ${
            isMoved
              ? "2xl:-translate-x-[179%] xl:-translate-x-[148%] lg:-translate-x-[118%] -translate-x-[99%] "
              : "-translate-x-1/2"
          }`}
        >
          {texts.map((item, index) =>
            item.isImage ? (
              <img
                key={index}
                src={item.imageSrc}
                alt={item.content}
                className={`w-32 transition-all duration-700 transform ${
                  visibleIndexes.includes(index)
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 -translate-y-5"
                }`}
              />
            ) : (
              <span
                key={index}
                className={`transition-all duration-700 transform ${
                  visibleIndexes.includes(index)
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 -translate-y-5"
                } ${item.className}`}
              >
                {item.content}
              </span>
            )
          )}
        </div>
        {/* 左側動畫字 md以下 */}
        <div className="md:hidden flex flex-row items-center w-full justify-center gap-2 text-2xl md:text-4xl font-bold text-center">
          {texts.map((item, index) =>
            item.isImage ? (
              <img
                key={index}
                src={item.imageSrc}
                alt={item.content}
                className={`w-24 h-6 transition-all duration-700 transform ${
                  visibleIndexes.includes(index)
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 -translate-y-5"
                }`}
              />
            ) : (
              <span
                key={index}
                className={`transition-all duration-700 transform ${
                  visibleIndexes.includes(index)
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 -translate-y-5"
                } ${item.className}`}
              >
                {item.content}
              </span>
            )
          )}
        </div>
        {/* 右側文字容器，固定寬度避免影響左側 */}
        <div
          className={`absolute md:right-0 md:top-0 w-[480px] md:translate-x-0 right-1/2 translate-x-1/2 top-20 transition-opacity duration-1000 ${
            showRightText ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="text-gray-400 text-sm md:text-regular tracking-wider md:text-right text-center leading-6 md:leading-8">
            lookie是結合地政與資訊而誕生的產品
            <br />
            <span className="text-main font-bold">land</span>代表地政
            <br />
            <span className="text-main font-bold">cookie</span>
            在web瀏覽器裡則是有紀錄的意涵
            <br />
            而look象徵著清查作業一目瞭然的期許
            <br />
            <span className="text-main font-bold">lookie</span>
            希望幫助您在地政作業時能更加輕鬆、便利、清楚
          </div>
        </div>
      </div>
    </div>
  );
};

export default DelayWords;
